import React from 'react'

export default function Expert() {
    return (
        <div className='Expert'>
            <img src="./img/living1.jpg" alt=""/>
                <div className="expert-inside">
                <p className="expert-saying">Based on your preferences
                we recommend a serene, blue-green hue like Make Waves for your living room.</p>
            </div>
        </div>
    )
}
